export const getCustomerId = () => {
  let curr = null;
  try {
    curr = window['ShopifyAnalytics'].meta.page.customerId;
  } catch (e) {}
  try {
    curr = window['meta'].page.customerId;
  } catch (e) {}
  try {
    curr = window['__st'].cid;
  } catch (e) {}

  if (curr !== undefined && curr !== null && curr !== '') {
    return curr;
  }

  return null;
};
